/**
 * API client for org_bornes management (associate bornes to organizations)
 */

const BASE_URL = import.meta.env.VITE_WATTELZCE_API_URL || '';

function getHeaders(): HeadersInit {
  const token = localStorage.getItem('dashboard_zce_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export interface OrgBorne {
  id: number;
  org_id: number;
  device_sn: string;
  borne_name: string;
  added_by: number | null;
  created_at: string;
}

/** List bornes for the current org (or acting client org in support mode) */
export async function getOrgBornes(): Promise<{ success: boolean; data?: OrgBorne[]; error?: string }> {
  const actingOrgId = sessionStorage.getItem('actingClientOrgId');
  const query = actingOrgId ? `?orgId=${actingOrgId}` : '';
  const res = await fetch(`${BASE_URL}/api/bornes${query}`, { headers: getHeaders() });
  return res.json();
}

/** Add a borne to the current org (or acting client org in support mode) */
export async function addOrgBorne(deviceSn: string, name: string): Promise<{ success: boolean; error?: string }> {
  const actingOrgId = sessionStorage.getItem('actingClientOrgId');
  const body: any = { deviceSn, name };
  if (actingOrgId) body.orgId = parseInt(actingOrgId, 10);
  const res = await fetch(`${BASE_URL}/api/bornes`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body),
  });
  return res.json();
}

/** Remove a borne from the current org */
export async function removeOrgBorne(id: number): Promise<{ success: boolean; error?: string }> {
  const actingOrgId = sessionStorage.getItem('actingClientOrgId');
  const query = actingOrgId ? `?orgId=${actingOrgId}` : '';
  const res = await fetch(`${BASE_URL}/api/bornes/${id}${query}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return res.json();
}
